<div [ngStyle]="style" >{{currentValue}}</div>